/**
 * @module /admin/widgets/analyze/store
 *
 * Vuex module for /admin/widgets/analyze
 */
export * from './state';
export * from './getters';
export * from './mutations';

export const namespaced = true;
